import { AccountNavigation } from './account_navigation';

export default AccountNavigation;
